import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MonitorService } from '../services/monitor.service';

@Component({
  standalone: false,
  selector: 'gstar-monitor',
  templateUrl: './monitor.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MonitorComponent {
  readonly monitorService = inject(MonitorService);
}
